import { Input } from "antd";
import { Button, Form, Grid, Modal, Popover, Popup, Radio, Selector, SelectorOption, Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { PageQueryParams } from "services/apis/cnt2/CommonDT";
import PostsApi, { PostsDataType } from "services/apis/cnt2/post-api";
import { postDownloadList, postSourceTypeMap } from "services/gather_bo/_total";
import { copy2Clipboard } from "utils/clipboardUtil";

const Post = () => {
  const [postList, setPostList] = useState<PostsDataType[]>([]);
  const [options, setOptions] = useState<SelectorOption<any>[]>([]);
  const [form] = Form.useForm();
  const [addForm] = Form.useForm();
  const [updateForm] = Form.useForm();

  const fetchPost = async (
    params: {
      cantCache?: boolean;
      termId?: string;
      termTaxonomy?: string;
    },
    _data: PageQueryParams
  ) => {
    // 请求接口
    const response = await PostsApi.page(params, { ..._data, sortParams: {}, dateTimeParams: {} });
    if (response.code === 0 && response.successful) {
      const data = response.result.records;
      setPostList(data);
    }
  };

  const searchPost = () => {
    fetchPost(
      { cantCache: true, termId: null, termTaxonomy: null },
      {
        // pageParams: { current: 1, pageSize: 100 },
        bizParams: {
          postUuid: form.getFieldValue("searchPostId") !== "" ? form.getFieldValue("searchPostId") : null,
          postTitle: form.getFieldValue("searchPostTitle") !== "" ? form.getFieldValue("searchPostTitle") : null,
          postSourceType:
            form.getFieldValue("searchPostSourceType").length !== 0
              ? form.getFieldValue("searchPostSourceType")[0]
              : null,
        },
      }
    );
  };

  useEffect(() => {
    // fetchPost({ cantCache: true, termId: null, termTaxonomy: null }, { pageParams: { current: 1, pageSize: 100 } });
    let _options = [];
    postSourceTypeMap.forEach((k, v) => {
      _options.push({ label: k, value: v });
    });
    setOptions(_options);
  }, []);

  return (
    <>
      <div>
        <div>
          {/* 搜索过滤 */}
          <div className=" flex flex-col gap-2 my-2 text-nowrap whitespace-nowrap">
            <div className=" text-center">过滤参数</div>
            <Form
              form={form}
              footer={
                <>
                  <Button
                    color="primary"
                    onClick={() => {
                      searchPost();
                    }}
                  >
                    搜索
                  </Button>
                </>
              }
            >
              <Form.Item name={"searchPostId"}>
                <div className=" flex items-center gap-2">
                  <div className=" w-24">帖子id</div>
                  <Input placeholder="精确搜索帖子id" />
                </div>
              </Form.Item>
              <Form.Item name={"searchPostTitle"}>
                <div className=" flex items-center gap-2">
                  <div className=" w-24">帖子标题</div>
                  <Input placeholder="模糊搜索帖子标题" />
                </div>
              </Form.Item>
              <Form.Item name={"searchPostSourceType"}>
                <Selector options={options} defaultValue={[]} multiple={false} />
              </Form.Item>
            </Form>
          </div>
          {/* 数据表格 */}
          <div className={[postList.length === 0 && "hidden"].join(" ")}>
            {/* 数据表头 */}
            <Grid columns={5} className=" text-center text-nowrap whitespace-nowrap px-2 py-1 bg-slate-200 rounded-md shadow-md my-2 text-base">
              <Grid.Item>帖子ID</Grid.Item>
              <Grid.Item span={2}>帖子标题</Grid.Item>
              <Grid.Item>帖子类型</Grid.Item>
              <Grid.Item>下载链接</Grid.Item>
            </Grid>
            {/* 数据内容 */}
            {postList.map((item) => (
              <div className=" mb-2 border-b-2 border-b-orange-500">
                <Grid
                  columns={5}
                  className=" text-center text-nowrap whitespace-nowrap px-2 py-1 shadow-md rounded-md bg-slate-100"
                >
                  {/* 数据项 帖子ID */}
                  <Grid.Item>
                    <div
                      className=" text-[#66f]"
                      onClick={() => {
                        copy2Clipboard(item.postUuid);
                        Toast.show("已复制: " + item.postUuid);
                      }}
                    >
                      复制
                    </div>
                  </Grid.Item>
                  {/* 数据项 帖子标题 */}
                  <Grid.Item span={2}>
                    <Popover
                      trigger="click"
                      placement="bottom"
                      defaultVisible={false}
                      content={item.postTitle}
                      children={
                        <>
                          <div className=" w-max-24 underline underline-offset-4 text-start">{item.postTitle}</div>
                        </>
                      }
                    />
                  </Grid.Item>
                  {/* 数据项 帖子类型 */}
                  <Grid.Item>{item.postSourceType}</Grid.Item>
                  {/* 数据项 下载链接 */}
                  <Grid.Item>
                    {
                      <Popover
                        trigger="click"
                        placement="left"
                        defaultVisible={false}
                        content={
                          <>
                            <div>{JSON.stringify(item.postDownloadInfo, null, 2)}</div>
                          </>
                        }
                        children={
                          <>
                            <div
                              onClick={() => {
                                // item.postDownloadInfo
                              }}
                              className=" text-sky-500"
                            >
                              点击查看
                            </div>
                          </>
                        }
                      />
                    }
                  </Grid.Item>
                </Grid>
                {/* 数据项 下载详情 */}
                {/* 数据项 下载详情 */}
                {/* 数据项 下载详情 */}
                <div className=" w-full p-2 bg-slate-50 rounded-md shadow-md my-2">
                  {item.postDownloadInfo?.length !== 0 && (
                    <>
                      <Grid columns={10} className="flex text-left items-center gap-2 p-2 border-b">
                        <Grid.Item span={2}>
                          <div>下载类型</div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                          <div>提取码</div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                          <div>解压码</div>
                        </Grid.Item>
                        <Grid.Item span={3}>
                          <div>下载链接</div>
                        </Grid.Item>
                        <Grid.Item span={2}>
                          <div>下载提示</div>
                        </Grid.Item>
                        <Grid.Item span={1}>
                          <div>操作</div>
                        </Grid.Item>
                      </Grid>
                      {item.postDownloadInfo?.map((postDownloadInfo) => (
                        <Grid columns={10} className="flex text-left items-center gap-2 px-2 py-1 border-b">
                          <Grid.Item span={2}>
                            <div>
                              {
                                postDownloadList.filter((item) => item.code === postDownloadInfo.downloadTypeCode)[0]
                                  .name
                              }
                              {postDownloadInfo.downloadUuid}
                            </div>
                          </Grid.Item>
                          <Grid.Item span={1}>
                            <div>{postDownloadInfo.extractionCode}</div>
                          </Grid.Item>
                          <Grid.Item span={1}>
                            <div>{postDownloadInfo.decompressionCode}</div>
                          </Grid.Item>
                          <Grid.Item span={3}>
                            <div>{postDownloadInfo.downloadUrl}</div>
                          </Grid.Item>
                          <Grid.Item span={2}>
                            <div>{postDownloadInfo.downloadNotice}</div>
                          </Grid.Item>
                          <Grid.Item span={1}>
                            <div className=" flex gap-2">
                              <div
                                className="text-[#f66]"
                                onClick={async () => {
                                  Modal.show({
                                    title: "修改数据",
                                    closeOnAction: true,
                                    closeOnMaskClick: true,
                                    showCloseButton: true,
                                    afterClose: () => {
                                      updateForm.resetFields();
                                    },
                                    actions: [
                                      {
                                        key: "confirm",
                                        text: (
                                          <>
                                            <Button
                                              color="primary"
                                              onClick={async () => {
                                                console.log(updateForm.getFieldsValue());
                                                Toast.show(postDownloadInfo.downloadUuid + "");
                                                if (
                                                  updateForm.getFieldValue("downloadTypeCode") &&
                                                  updateForm.getFieldValue("downloadUrl")
                                                ) {
                                                  const resp = await PostsApi.alterPostDownloadInfo(
                                                    { postId: item.postUuid },
                                                    {
                                                      postDownloadInfo: {
                                                        ...updateForm.getFieldsValue(),
                                                        downloadUuid: postDownloadInfo.downloadUuid,
                                                        downloadTypeCode: postDownloadInfo.downloadTypeCode,
                                                      },
                                                    }
                                                  );
                                                  if (resp.successful) {
                                                    Toast.show("已修改");
                                                    searchPost();
                                                  } else {
                                                    Toast.show("添加失败");
                                                  }
                                                } else {
                                                  Toast.show("数据不全");
                                                }
                                              }}
                                            >
                                              修改数据
                                            </Button>
                                          </>
                                        ),
                                      },
                                    ],
                                    content: (
                                      <>
                                        <Form form={updateForm} layout="horizontal" className=" text-nowrap">
                                          <Form.Item name={"downloadUuid"} initialValue={postDownloadInfo.downloadUuid}>
                                            <div className=" flex items-center gap-2">
                                              <div className=" w-24">下载标识</div>
                                              <Input
                                                placeholder="下载标识"
                                                readOnly
                                                defaultValue={postDownloadInfo.downloadUuid + ""}
                                              />
                                            </div>
                                          </Form.Item>
                                          <Form.Item
                                            name={"downloadTypeCode"}
                                            initialValue={postDownloadInfo.downloadTypeCode}
                                          >
                                            {/* <Radio.Group defaultValue={postDownloadInfo.downloadTypeCode + ""}>
                                                  {postDownloadList.map((item, index) => (
                                                    <Radio value={item.code + ""}>{item.name}</Radio>
                                                  ))}
                                                </Radio.Group> */}
                                            <div className=" flex items-center gap-2">
                                              <div className=" w-24">下载类型</div>
                                              <Input
                                                placeholder="下载类型"
                                                readOnly
                                                defaultValue={postDownloadInfo.downloadTypeCode + ""}
                                              />
                                            </div>
                                          </Form.Item>
                                          <Form.Item
                                            name={"extractionCode"}
                                            initialValue={postDownloadInfo.extractionCode}
                                          >
                                            <div className=" flex items-center gap-2">
                                              <div className=" w-24">提取码</div>
                                              <Input
                                                placeholder="提取码"
                                                defaultValue={postDownloadInfo.extractionCode + ""}
                                              />
                                            </div>
                                          </Form.Item>
                                          <Form.Item
                                            name={"decompressionCode"}
                                            initialValue={postDownloadInfo.decompressionCode}
                                          >
                                            <div className=" flex items-center gap-2">
                                              <div className=" w-24">解压码</div>
                                              <Input
                                                placeholder="解压码"
                                                defaultValue={postDownloadInfo.decompressionCode + ""}
                                              />
                                            </div>
                                          </Form.Item>
                                          <Form.Item name={"downloadUrl"} initialValue={postDownloadInfo.downloadUrl}>
                                            <div className=" flex items-center gap-2">
                                              <div className=" w-24">下载链接</div>
                                              <Input
                                                placeholder="下载链接"
                                                defaultValue={postDownloadInfo.downloadUrl + ""}
                                              />
                                            </div>
                                          </Form.Item>
                                          <Form.Item
                                            name={"downloadNotice"}
                                            initialValue={postDownloadInfo.downloadNotice}
                                          >
                                            <div className=" flex items-center gap-2">
                                              <div className=" w-24">下载提示</div>
                                              <Input
                                                placeholder="下载提示"
                                                defaultValue={postDownloadInfo.downloadNotice + ""}
                                              />
                                            </div>
                                          </Form.Item>
                                        </Form>
                                      </>
                                    ),
                                  });
                                }}
                              >
                                修改
                              </div>
                              <div
                                className="text-[#f00]"
                                onClick={async () => {
                                  const resp = await PostsApi.delPostDownloadInfo({
                                    postId: item.postUuid,
                                    postDownloadInfoId: postDownloadInfo.downloadUuid + "",
                                  });
                                  if (resp.successful) {
                                    searchPost();
                                  } else {
                                    Toast.show("删除失败");
                                  }
                                }}
                              >
                                删除
                              </div>
                            </div>
                          </Grid.Item>
                        </Grid>
                      ))}
                    </>
                  )}
                  <>
                    {/* 新增下载 */}
                    <Grid.Item
                      span={5}
                      className="text-[#66f] w-full p-2 text-center"
                      onClick={() => {
                        Modal.show({
                          title: "新增数据",
                          closeOnAction: true,
                          closeOnMaskClick: true,
                          showCloseButton: true,
                          afterClose: () => {
                            addForm.resetFields();
                          },
                          actions: [
                            {
                              key: "confirm",
                              text: (
                                <>
                                  <Button
                                    color="primary"
                                    onClick={async () => {
                                      console.log(addForm.getFieldsValue());
                                      if (
                                        addForm.getFieldValue("downloadTypeCode") &&
                                        addForm.getFieldValue("downloadUrl")
                                      ) {
                                        const resp = await PostsApi.addPostDownloadInfo(
                                          { postId: item.postUuid },
                                          {
                                            postDownloadInfo: addForm.getFieldsValue(),
                                          }
                                        );
                                        if (resp.successful) {
                                          Toast.show("已添加");
                                          addForm.resetFields();
                                          searchPost();
                                        } else {
                                          Toast.show("添加失败");
                                        }
                                      } else {
                                        Toast.show("数据不全");
                                      }
                                    }}
                                  >
                                    新增数据
                                  </Button>
                                </>
                              ),
                            },
                          ],
                          content: (
                            <>
                              <Form form={addForm} layout="horizontal" className=" text-nowrap">
                                <Form.Item name={"downloadTypeCode"}>
                                  <Radio.Group>
                                    {postDownloadList.map((item) => (
                                      <Radio value={item.code + ""}>{item.name}</Radio>
                                    ))}
                                  </Radio.Group>
                                </Form.Item>
                                <Form.Item name={"extractionCode"}>
                                  <div className=" flex items-center gap-2">
                                    <div className=" w-24">提取码</div>
                                    <Input placeholder="提取码" />
                                  </div>
                                </Form.Item>
                                <Form.Item name={"decompressionCode"}>
                                  <div className=" flex items-center gap-2">
                                    <div className=" w-24">解压码</div>
                                    <Input placeholder="解压码" />
                                  </div>
                                </Form.Item>
                                <Form.Item name={"downloadUrl"}>
                                  <div className=" flex items-center gap-2">
                                    <div className=" w-24">下载链接</div>
                                    <Input placeholder="下载链接" />
                                  </div>
                                </Form.Item>
                                <Form.Item name={"downloadNotice"}>
                                  <div className=" flex items-center gap-2">
                                    <div className=" w-24">下载提示</div>
                                    <Input placeholder="下载提示" />
                                  </div>
                                </Form.Item>
                              </Form>
                            </>
                          ),
                        });
                      }}
                    >
                      <Button color="warning" size="small">
                        新增下载
                      </Button>
                    </Grid.Item>
                  </>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Post;
